import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ContentSchemaRender } from "~/components/content/content-schema-render";
import type { contentSubHeadlineContent$key } from "~/queries/__generated__/contentSubHeadlineContent.graphql";

import { ContentSubHeadlineContainer } from "./styles";

export type Props = {
  reference: contentSubHeadlineContent$key;
};

export const ContentSubHeadline: FunctionComponent<Props> = ({
  reference: reference_,
  ...attribs
}) => {
  const content = useFragment(
    graphql`
      fragment contentSubHeadlineContent on Content {
        subHeadline {
          json
        }
        ...contentSchemaRenderContent
      }
    `,
    reference_,
  );

  if (!content.subHeadline?.json?.length) return null;

  return (
    <ContentSubHeadlineContainer {...attribs}>
      <ContentSchemaRender reference={content} schema={content.subHeadline?.json} />
    </ContentSubHeadlineContainer>
  );
};

ContentSubHeadline.displayName = "ContentSubHeadline";
